import http from "./HttpService";

const BASE_SERVICE_URL = "estore-service";

export default {
  getStoreDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL +
            "/v3/customer/estore/settings/store/details",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicStoreDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL +
            "/v1/public/customer/estore/settings/store/details",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicProducts(request) {
    request.payload["customer_channel"] = "estore_web";
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v7/public/customer/estore/products/${request.page}`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getProducts(request) {
    request.payload["customer_channel"] = "estore_web";
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v7/customer/estore/products/${request.page}`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getSpecificProduct(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v1/customer/estore/product/inventory",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getSpecificPublicProduct(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v1/public/customer/estore/product/inventory",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getCategories(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/v1/customer/estore/category/brand/list",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicCategories(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL +
            "/v4/public/customer/estore/product/categories/all",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getOrders(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v2/customer/estore/order",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getOrderDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL +
            "/v4/customer/estore/order/transaction/details/" +
            request.id,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicOrderDetails(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL +
            `/v4/public/customer/estore/order/transaction/details/${request.id}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  addToCart(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v5/customer/estore/cart/item/add",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  guestAddToCart(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v5/public/customer/estore/cart/item/add`,
          request.payload,
          request.header
        )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  editCart(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL +
            "/v3/customer/estore/cart/item/update/" +
            request.cart_item_uuid.cart_item_uuid,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  guestEditCart(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v3/public/customer/estore/cart/item/update`,
          request.payload,
          request.header
        )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  removeItem(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v4/customer/estore/cart/item/delete",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  guestRemoveItem(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v4/public/customer/estore/cart/item/delete`,
          request.payload,
          request.header
        )
        .then(response => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  viewCart(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v5/customer/estore/cart/item/list",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  viewPublicCart(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v5/public/customer/estore/cart/item/list`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  uploadCustomerDepositSlip(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v2/customer/estore/order/deposit_slip",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkout(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v7/customer/estore/cart/checkout",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkoutPublic(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v7/public/customer/estore/cart/checkout",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  verifyVoucher(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v1/customer/estore/cart/voucher/verify",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  applyVoucher(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          BASE_SERVICE_URL + "/v1/customer/estore/cart/voucher/save",
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  removeVoucher(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          BASE_SERVICE_URL + "/v1/customer/estore/cart/voucher/remove",
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updateDelivery(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v5/customer/estore/cart/delivery_type/update`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updatePublicDelivery(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v5/public/customer/estore/cart/delivery_type/update`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  addBilling(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/address/billing/add`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  paynamics(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `payments-service/transact/paynamics`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  gcashPaynamics(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `payments-service/transact/paynamics/gcash`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getWebDesign(request) {
    return new Promise((resolve, reject) => {
      http
        .get("design-service/customer/web/get-design", request.header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkPaymentStatus(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          "payments-service/transact/paynamics/response",
          request.order_id,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkBranches(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `estore-service/v3/customer/estore/cart/check/location`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  checkPublicBranches(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `estore-service/v3/public/customer/estore/cart/check/location`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getDeliveryOptions(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          // `organization-service/public/branch/view/details/`+request.uuid,
          `organization-service/customer/branch/view/details/` + request.uuid,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  followUpOrder(request) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v1/customer/estore/order/send/follow_up/${request.uuid}`,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  cancelOrder(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/order/cancel`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  // MEDPadala
  medPadalaBalanceInquiry(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v2/customer/estore/cart/med-padala/balance-inquiry`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  medPadalaSaveAmount(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/cart/med-padala/save`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  medPadalaRemove(request) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/cart/med-padala/remove`,
          null,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  payViaPayMongo({ payload, header }) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/payment/paymongo/add${
            payload.type === "gcash" || payload.type === "grab_pay"
              ? "/source"
              : ""
          }`,
          payload,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getPayMongoPaymentIntent({ id, header }) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `payments-service/v1/customer/paymongo/payment/intents/${id}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  deletePayMongoPaymentMethod({ transactionNumber, header }) {
    return new Promise((resolve, reject) => {
      http
        .delete(
          `payments-service/v1/customer/paymongo/payment/methods/${transactionNumber}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getPublicProductsByCategory(request) {
    request.payload["customer_channel"] = "estore_web";
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v5/public/customer/estore/product/list/categories/${request.categoryId}/pages/${request.page}`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getProductsByCategory(request) {
    request.payload["customer_channel"] = "estore_web";
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v5/customer/estore/product/list/categories/${request.categoryId}/pages/${request.page}`,
          request.payload,
          request.header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getDeleteAccountStatus({ header }) {
    return new Promise((resolve, reject) => {
      http
        .get(`${BASE_SERVICE_URL}/v1/customer/estore/deactivate/status`, header)
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  getAvailableCodes({ header, payload, page }) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/estore/promo-codes/list/${page}`,
          payload,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  applySpecialDiscountToCart({ header, payload }) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/cart/special_discount/apply`,
          payload,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  applySpecialDiscountToOrder({ header, payload }) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/special_discount/apply`,
          payload,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  validateSpecialDiscount({ header, orderUuid }) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `${BASE_SERVICE_URL}/v1/customer/special_discount/validate/${orderUuid}`,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  updateOrderSpecialDiscount({ header, payload }) {
    return new Promise((resolve, reject) => {
      http
        .post(
          `${BASE_SERVICE_URL}/v1/customer/special_discount/update`,
          payload,
          header
        )
        .then(response => {
          return resolve(response);
        })
        .catch((status, errors) => {
          reject(status, errors);
        });
    });
  },
  deleteSpecialDiscount(request) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/v1/customer/special_discount/delete`,
        request.payload,
        request.header
      )
      .then((response) => resolve(response))
      .catch((status, error) => reject(status, error));
    });
  },
  getPointDetails({ payload, header }) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/v1/customer/pay-with-points/details`,
        payload,
        header
      )
      .then((response) => resolve(response))
      .catch((status, error) => reject(status, error));
    });
  },
  redeemPoints({ payload, header }) {
    return new Promise((resolve, reject) => {
      http.post(
        `${BASE_SERVICE_URL}/v1/customer/pay-with-points/redeem`,
        payload,
        header
      )
      .then((response) => resolve(response))
      .catch((status, error) => reject(status, error));
    });
  }
};
